module.exports = __webpack_public_path__ + "assets/img/THEX-video-01.ff1565a2.jpg";